import { Table } from "antd";
import React, { useMemo } from "react";
import { LIMIT_PERIOD_I18N_KEYS } from "../../constants";
import {
	ProgressFill,
	ProgressTrack,
	StyledTableWrapper,
	TableSection,
	UsageCell,
} from "./elements";

const LimitsResultsTable = ({ translate, rows, selectedPeriod }) => {
	const columns = useMemo(
		() => [
			{
				title: translate("limits.table.period"),
				dataIndex: "period",
				key: "period",
				width: 130,
				render: (period) => (
					<span className={period === selectedPeriod ? "limits-period-active" : ""}>
						{translate(LIMIT_PERIOD_I18N_KEYS[period])}
					</span>
				),
			},
			{
				title: translate("limits.usage"),
				dataIndex: "displayUsage",
				key: "displayUsage",
			},
			{
				title: translate("limits.limit"),
				dataIndex: "displayLimit",
				key: "displayLimit",
			},
			{
				title: translate("limits.remaining"),
				dataIndex: "displayRemaining",
				key: "displayRemaining",
			},
			{
				title: translate("limits.table.progress"),
				key: "progress",
				width: 120,
				render: (_, row) =>
					row.limit?.effectiveMax ? (
						<UsageCell>
							<ProgressTrack>
								<ProgressFill $percent={row.progressPercent} />
							</ProgressTrack>
						</UsageCell>
					) : (
						"—"
					),
			},
		],
		[selectedPeriod, translate]
	);

	return (
		<TableSection>
			<StyledTableWrapper>
				<Table
					columns={columns}
					dataSource={rows}
					pagination={false}
					scroll={{ x: 600 }}
					size="middle"
					rowClassName={(record) =>
						record.period === selectedPeriod ? "limits-row-selected" : ""
					}
				/>
			</StyledTableWrapper>
		</TableSection>
	);
};

export default LimitsResultsTable;
